import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m20.689.535.319.085-9.901 9.544a7.532 7.532 0 0 0-2.305 3.63c-.758 2.691-.108 5.173 1.797 7.035l-5.967 5.758C.673 22.75-.982 17.27.587 11.7 2.947 3.318 11.877-1.71 20.689.535Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20.434 17.021c-.663 2.351-3.203 3.746-5.675 3.116-2.472-.63-3.938-3.046-3.276-5.397.662-2.351 3.203-3.746 5.674-3.116 2.472.63 3.939 3.046 3.277 5.397Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.152 31.465a17.355 17.355 0 0 1-.32-.085l9.98-9.544a7.525 7.525 0 0 0 2.323-3.63c.764-2.691.093-5.217-1.827-7.08l5.98-5.776c3.99 3.838 5.71 9.38 4.129 14.95-2.38 8.382-11.382 13.41-20.265 11.165Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }